import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AllocateStudents = () => {
  const storedSessionId = localStorage.getItem('currentSessionId');

  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState('');
  const [buses, setBuses] = useState([]);
  const [selectedBus, setSelectedBus] = useState('');
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState('');
  const [students, setStudents] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [busCapacity, setBusCapacity] = useState(0);
  const [allocatedStudentIds, setAllocatedStudentIds] = useState([]); // already allocated
  const [allocatedStudents, setAllocatedStudents] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [allocationDate, setAllocationDate] = useState("");
  // --- Fetch routes and classes ---
  useEffect(() => {
    if (!storedSessionId) return;

    axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/busroutes/getBusRoutes?sessionId=${storedSessionId}`)
      .then(res => setRoutes(res.data))
      .catch(err => console.error(err));

    axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${storedSessionId}`)
      .then(res => setClasses(res.data))
      .catch(err => console.error(err));
  }, [storedSessionId]);

  // --- Fetch buses ---
  useEffect(() => {
    if (!storedSessionId) return;

    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/busdetails/getAllBusDetails`, { params: { sessionId: storedSessionId } })
      .then(res => setBuses(res.data))
      .catch(err => console.error(err));
  }, [storedSessionId]);

  useEffect(() => {
  if (!selectedRoute || !storedSessionId) {
    setLocations([]);
    return;
  }

  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/locations/${selectedRoute}/getAllBusLocations`,
    { params: { sessionId: storedSessionId } }
  )
    .then(res => setLocations(res.data))
    .catch(err => console.error(err));
}, [selectedRoute, storedSessionId]);

  // --- Set bus capacity ---
  useEffect(() => {
    const bus = buses.find(b => b.busNumber === selectedBus);
    if (bus) setBusCapacity(bus.studentCapacity);
    else setBusCapacity(0);
  }, [selectedBus, buses]);

  // --- Fetch sections ---
  useEffect(() => {
    if (!selectedClass || !storedSessionId) return;

    const selectedClassName = classes.find(c => c._id === selectedClass)?.className;
    if (!selectedClassName) return;

    axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${encodeURIComponent(selectedClassName)}/getSectionsByClassName?sessionId=${storedSessionId}`)
      .then(res => setSections(Array.isArray(res.data) ? res.data : res.data.sections || []))
      .catch(err => console.error(err));
  }, [selectedClass, storedSessionId, classes]);

  // --- Fetch students ---
 // --- Fetch students ---
useEffect(() => {
  if (!selectedClass || !selectedSection || !storedSessionId) {
    setStudents([]);
    return;
  }

  const selectedClassName = classes.find(c => c._id === selectedClass)?.className;
  if (!selectedClassName) return;

  axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`, {
    params: {
      sessionId: storedSessionId,
      class: selectedClassName,
      section: selectedSection,
      status: 'active'
    }
  })
  .then(async res => {

    // ✅ REMOVE transportationMode filter
    const filtered = res.data.filter(s =>
      s.class === selectedClassName &&
      s.section.toLowerCase() === selectedSection.toLowerCase() &&
      s.status === 'active'
    );

    // Get allocated students from bus schedules
    const scheduleRes = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/busSchedules?session=${storedSessionId}`
    );

    const schedules = scheduleRes.data;
    const allocatedMap = {};

    schedules.forEach(bus => {
      bus.students.forEach(stu => {
        allocatedMap[stu._id] = {
          busNumber: bus.busNumber,
          route: stu.route,
          location: stu.location
        };
      });
    });

    const updatedStudents = filtered.map(s => ({
      ...s,
      allocated: !!allocatedMap[s._id],
      busNumber: allocatedMap[s._id]?.busNumber || null,
      routeName: allocatedMap[s._id]?.route || '',
      location: allocatedMap[s._id]?.location || '',
    }));

    setStudents(updatedStudents);
    setSelectedStudents([]);
    setSelectAll(false);
  })
  .catch(err => console.error(err));

}, [selectedClass, selectedSection, storedSessionId, classes]);

  // --- Handlers ---
  const handleSelectStudent = studentId => {
    if (selectedStudents.includes(studentId)) {
      setSelectedStudents(selectedStudents.filter(id => id !== studentId));
    } else {
      setSelectedStudents([...selectedStudents, studentId]);
    }
  };

  const handleSelectAll = () => {
    const selectableIds = students.filter(s => !s.allocated).map(s => s._id);
    setSelectedStudents(selectAll ? [] : selectableIds);
    setSelectAll(!selectAll);
  };

const handleSubmit = async () => {
  if (!selectedBus || selectedStudents.length === 0) return alert("Select bus & students.");
if (!allocationDate) {
  return alert("Please select allocation date");
}
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/allocateStudentsToBus/${selectedBus}?session=${storedSessionId}`;
    console.log("Allocating students to:", url);

    await axios.post(
      url,
      { 
        allocationDate,
        students: selectedStudents.map(id => {
          const s = students.find(st => st._id === id);
          return {
            _id: s._id,
            name: `${s.firstName} ${s.lastName}`,
            class: s.class,
            section: s.section,
            route: routes.find(r => r._id === selectedRoute)?.routeName || '',
            location: selectedLocation
          };
        })
      },
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );

    alert("Students allocated and ledger updated!");
  } catch (err) {
    console.error("Allocation error:", err.response?.data || err.message);
    alert(err.response?.data?.message || "Failed to allocate students");
  }
};

  const handleReallocate = async (studentId) => {
    if (!selectedBus) {
      alert("Please select a new bus.");
      return;
    }

    const student = students.find(s => s._id === studentId);
    if (!student) {
      alert("Student not found.");
      return;
    }

    const currentBus = student.busNumber;
    if (!currentBus) {
      alert("Current bus not found for this student.");
      return;
    }

    if (currentBus === selectedBus) {
      alert("Student is already assigned to this bus.");
      return;
    }

    try {
    await axios.post(
  `${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/reallocateStudent/${currentBus}?session=${storedSessionId}`,
  {
    studentId,
    newBusNumber: selectedBus,
    newRoute: routes.find(r => r._id === selectedRoute)?.routeName,
    newLocation: selectedLocation
  },
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }
);



      alert("Student successfully reallocated!");
  
     setStudents(prev =>
  prev.map(s =>
    s._id === studentId
      ? {
          ...s,
          busNumber: selectedBus,
          routeName: selectedRoute,
          location: s.location // or selectedLocation
        }
      : s
  )
);

    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to reallocate student.");
    }
  };
const handleDeallocate = async (studentId) => {
  try {

    await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/deallocateStudent?session=${storedSessionId}`,
      { studentId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      }
    );

    alert("Student deallocated successfully");

    // ✅ Update UI
    setStudents(prev =>
      prev.map(s =>
        s._id === studentId
          ? {
              ...s,
              busNumber: null,
              routeName: "",
              location: "",
              allocated: false
            }
          : s
      )
    );

  } catch (err) {
    console.error(err);
    alert(err.response?.data?.message || "Failed to deallocate");
  }
};
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        {/* Class Selection */}
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Select Class:</label>
          <select value={selectedClass} onChange={e => setSelectedClass(e.target.value)} className="border rounded-lg p-2 w-full">
            <option value="">Select a class</option>
            {classes.map(c => <option key={c._id} value={c._id}>{c.className}</option>)}
          </select>
        </div>

        {/* Section Selection */}
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Select Section:</label>
          <select value={selectedSection} onChange={e => setSelectedSection(e.target.value)} className="border rounded-lg p-2 w-full" disabled={!selectedClass}>
            <option value="">Select a section</option>
            {sections.map(s => <option key={s._id} value={s.sectionName}>{s.sectionName}</option>)}
          </select>
        </div>

        {/* Route Selection */}
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Select Route:</label>
          <select
  value={selectedRoute}
  onChange={e => {
    setSelectedRoute(e.target.value);
    setSelectedLocation(''); // reset location when route changes
  }}
  className="border rounded-lg p-2 w-full"
>
  <option value="">Select a route</option>
  {routes.map(r => (
    <option key={r._id} value={r._id}>
      {r.routeName}
    </option>
  ))}
</select>

        </div>
        {/* Location Selection */}
<div className="mb-6">
  <label className="block text-gray-700 mb-2">Select Location:</label>
  <select
    value={selectedLocation}
    onChange={e => setSelectedLocation(e.target.value)}
    className="border rounded-lg p-2 w-full"
    disabled={!selectedRoute}
  >
    <option value="">Select a location</option>
    {locations.map((loc, index) => (
      <option key={index} value={loc.location}>
        {loc.location}
      </option>
    ))}
  </select>
</div>

        
        {/* Bus Selection */}
        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Select Bus:</label>
          <select value={selectedBus} onChange={e => setSelectedBus(e.target.value)} className="border rounded-lg p-2 w-full" disabled={!selectedRoute}>
            <option value="">Select a bus</option>
            {buses.map(b => <option key={b._id} value={b.busNumber}>{b.busNumber}</option>)}
          </select>
        </div>

        {/* Students Table */}
        <div className="overflow-x-auto mb-6">
          <table className="min-w-full bg-white border border-gray-300 text-center">
            <thead className="bg-gray-200">
              <tr>
                <th className="py-2 px-4 border">
                  <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                </th>
                <th className="py-2 px-4 border">Index</th>
                <th className="py-2 px-4 border">Student Name</th>
                <th className="py-2 px-4 border">Class</th>
                <th className="py-2 px-4 border">Section</th>
                <th className="py-2 px-4 border">Route</th>
                <th className="py-2 px-4 border">Location</th>
                <th className="py-2 px-4 border">Bus Number</th>
              </tr>
            </thead>
            <tbody>
              {students.map((s, idx) => (
                <tr key={s._id} className="hover:bg-gray-100">
                  <td className="border px-4 py-2">
                    <input 
                      type="checkbox" 
                      checked={selectedStudents.includes(s._id)} 
                      onChange={() => handleSelectStudent(s._id)} 
                      disabled={s.allocated} // only allow unallocated for bulk allocation
                    />
                  </td>
                  <td className="border px-4 py-2">{idx + 1}</td>
                  <td className="border px-4 py-2">{s.firstName} {s.lastName}</td>
                  <td className="border px-4 py-2">{s.class}</td>
                  <td className="border px-4 py-2">{s.section}</td>
                  <td className="border px-4 py-2">{s.routeName || 'N/A'}</td>
                  <td className="border px-4 py-2">{s.location || 'N/A'}</td>
                  <td className="border px-4 py-2">
                    {s.busNumber ? (
  <div className="flex justify-center items-center gap-2">
    <span className="text-green-600 font-semibold">{s.busNumber}</span>

    <button
      className="px-2 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-400"
      onClick={() => handleReallocate(s._id)}
    >
      Reallocate
    </button>

    <button
      className="px-2 py-1 bg-red-600 text-white rounded hover:bg-red-500"
      onClick={() => handleDeallocate(s._id)}
    >
      Deallocate
    </button>
  </div>
) : (
                      <span className="text-gray-400">Not Allocated</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
{/* Allocation Date */}
<div className="mb-6">
  <label className="block text-gray-700 mb-2">
    Select Allocation Date:
  </label>

  <input
    type="date"
    value={allocationDate}
    onChange={(e) => setAllocationDate(e.target.value)}
    className="border rounded-lg p-2 w-full"
  />
</div>
        {/* Submit Button */}
        <div>
          <button onClick={handleSubmit} className="px-6 py-2 bg-blue-800 text-white rounded-md hover:bg-blue-600">
            Allocate Students
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllocateStudents;
